export const CountryTimeFormatter = {
    '1': 12, //usa
    '2': 24, //uk
    '3': 12, //canada
    '4': 24, //fra
    '5': 24,  //mexico
    '6': 24,  //japan
    '7': 24,  //australia
    '8': 24, //germany
    '9': 24, //spain
    '10': 24, //south korea
    '11': 24, //italy
}